import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserDatosService {

  constructor(
    private http: HttpClient
  ) { }

  getAccount(){    
    return this.http.get(`${environment.baseUrl}/settings/account`);
  }

}
